import { ApiEndpoints } from '../../../utils/app-constants';
import { toCondensedDate } from '../../../utils/date-utils';
import { 
    DOCUMENT_EXTENSIONS,
    DOCUMENT_REQUEST_LOCATION, 
    IDocumentRequest 
} from '../../utilities/document-request';
import { API_METHODS } from '../../utilities/type-models';

export class OpenOrdersReportDocument implements IDocumentRequest {

    public filename : string = '';
    public fileExtension : DOCUMENT_EXTENSIONS = 'xlsx';
    public openInTab : boolean = false;
    public reportLocation : DOCUMENT_REQUEST_LOCATION = 'api';
    public methodType : API_METHODS = 'GET';

    public url : string = '';

    constructor(date : Date) {       
        this.url = ApiEndpoints.ACCOUNTING_OPEN_ORDERS;
        this.filename = `orders_${ toCondensedDate(date) }`;
    }

}
